export default __webpack_public_path__ + "static/media/img-33-taikuri.bf10fed9.jpg";